// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"3da5ce85","220":"dd57eeb0","703":"a4e9a26b","799":"7b38123f"}[chunkId] + ".chunk.js";
};